import { Switch } from "@mui/material"
import { useState, useEffect } from "react"
import PodcastsIcon from '@mui/icons-material/Podcasts';
import PersonIcon from '@mui/icons-material/Person';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PixIcon from '@mui/icons-material/Pix';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {db, storage} from './firebase'
import {addDoc, collection, doc, getDocs, updateDoc, getDoc, setDoc, query, arrayUnion} from 'firebase/firestore'
import SearchIcon from '@mui/icons-material/Search';
import useForm from "./hooks/useForm";
import {Checkbox} from "@mui/material";
import ArticleIcon from '@mui/icons-material/Article';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import axios from 'axios';
import { BASE_URL } from './utils/Scripts'
import { useIsMobile } from "./context/MobileContext";

const boxShadow = `0px 0px 30px -11px rgba(0,0,0,0.5)`

function UserDisplay(props:any){

    const [display, setDisplay] = useState(false)
    const isMobile = useIsMobile()

    return(
        <div style={{display:'flex', flexDirection:'column', width:'90%', alignItems:'center', padding:'0 10px 0 10px'}}>
            <div style={{display:'flex', width:'100%', alignItems:"center", height:'40px', cursor:'pointer'}} onClick={()=>{setDisplay(!display)}}>
                <div style={{fontSize:'12px'}}>{props.acc.email}</div>
                <div style={{marginLeft:'auto'}}><ArrowDropDownIcon/></div>
            </div>
            <div style={{display:!display?'none':'flex', width:'100%', alignItems:"center", height:'15px', fontSize:'12px', fontWeight:'600'}}>
                <div style={{marginLeft:'20px'}}>Roles: [
                    {props.acc.roles.map((role:any, index:any)=>{
                        if(index==0){
                            return(role)
                        } else {
                            return(', '+role)
                        }
                        })}]</div>
            </div>
        </div>
    )
}

function Form(props:any){

    const [focus, setFocus] = useState(false)
    const [text, setText] = useState(props.defVal)
    const {setForm, form}:any = useForm()

    useEffect(()=>{
        if(focus){
            document.getElementById(props.id)?.focus()
            document.getElementById(props.id)?.addEventListener('focusout', ()=>{
                setFocus(false)
            })
            
        } else {
            if(!text){
                setText(props.defVal)
            }
        }
    },[focus])

    useEffect(()=>{
        if(document.getElementById(props.id)){
            document.getElementById(props.id)!.style.width = text.length+'ch'
        }
        if(form[props.id]!=undefined){
            let old_form = {...form}
            old_form[props.id] = text
            setForm(old_form)
        }
    },[text])

    useEffect(()=>{
        setText(props.defVal)
    },[props.defVal])

    return(
        <div>
            {focus&&(
                <div>
                    <input id={props.id} type='text' onChange={(e)=>{setText(e.target.value)}} value={text} style={{border:'none', textAlign:'right', width:props.defVal.length+'ch', maxWidth:'100px', fontSize:'16px', outline:'none', backgroundColor:'transparent'}}/>
                </div>
            )}
            {!focus&&(<span onClick={()=>{setFocus(true)}}>{text}</span>)}
        </div>
    )
}

function CheckItems(props:any){

    const [checked, setChecked] = useState(true)

    return(
        <div style={{display:'flex', float:'left', alignItems:'center', width:'fitContent', cursor:'pointer', fontSize:'11px', fontWeight:'600', margin:'5px 7px'}} onClick={()=>{setChecked(!checked)}}>
            <Checkbox size='small' sx={{ '&:hover': { bgcolor: 'transparent' }, padding:'0' }} checked={checked}/>
            <div style={{marginLeft:'0px'}}>{props.label} ({props.number})</div>
        </div>
    )
}

function EmailSelection(props:any){

    const [selected, setSelected] = useState(true)

    return(
        <div style={{margin:'2px', fontSize:'12px', backgroundColor:selected?'#e8f5f7':'transparent', padding:selected?'3px':'4px', borderRadius:'4px', border:selected?'1px solid #c1def0':'none', fontWeight:'500', cursor:'pointer'}} onClick={()=>{setSelected(!selected)}}>
            {props.email.toUpperCase()}
        </div>
    )
}

export function Panel(props:any){

    const {setForm, form}:any = useForm()

    const [checked, setChecked] = useState(true)
    const [labData, setLabData] = useState<any>([])
    const [currentLab, setCurrentLab] = useState(0)
    const [participants, setParticipants] = useState<any>([])
    const [accounts, setAccounts] = useState([])
    const [filterAccounts, setFilterAccounts] = useState([])
    const [dropdown, setDropdown] = useState(false)
    const [contactWindow, setContactWindow] = useState(0)

    async function getLabs(){
        // const snapshot = await getDoc(doc(db, 'arcalab_utils', 'lab_list'))
        const options ={
            url:BASE_URL+'arcalab_firestore',
            method:'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
            },
            data:{
                type:'getDoc',
                collection:'arcalab_utils',
                doc:'lab_list'
            }
        }
        let data:any = await axios(options)
        for(let a=0;a<data.data.lab_list.length;a++){
            Object.keys(data.data.lab_list[a]).forEach((key)=>{
                if(typeof(data.data.lab_list[a][key])=='number'){
                    data.data.lab_list[a][key] = String(data.data.lab_list[a][key])
                }
            })
        }
        setCurrentLab(data.data.lab_list.length-1)
        setLabData(data.data.lab_list)
    }

    async function getParticipants(){
        let parts:any = []
        // const snap = await getDocs(query(collection(db, 'arcalab_orders')))
        const options ={
            url:BASE_URL+'arcalab_firestore',
            method:'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
            },
            data:{
                type:'getDocs',
                collection:'arcalab_orders'
            }
        }
        const snap = await axios(options)
        snap.data.map((d:any)=>{
            const index = labData.findIndex((obj:any)=> obj.id==d.data.lab_id)
            if(parts[index]!=undefined){
                parts[index].push(d.data)
            } else {
                parts[index] = [d.data]
            }
        })
        setParticipants(parts)
    }

    async function getAccounts(){
        // const snapshot = await getDocs(collection(db, 'arcalab_accounts'))
        const options ={
            url:BASE_URL+'arcalab_firestore',
            method:'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
            },
            data:{
                type:'getDocs',
                collection:'arcalab_accounts'
            }
        }
        const snapshot = await axios(options)
        let accs:any = []
        snapshot.data.map((doc:any)=>{
            const object = {
                email: doc.data.email,
                roles: doc.data.roles
            }
            accs.push(object)
        })
        setAccounts(accs)
    }

    async function goSave(){
        const types:any = {
            active: false,
            date: '',
            id: '',
            link_zoom: '',
            max_online: 0,
            max_presencial: 0,
            price_online: 0,
            price_presencial: 0
        }

        let newObject = labData
        newObject[currentLab] = {...form}
        for(let a=0;a<newObject.length;a++){
            Object.keys(newObject[a]).forEach((key)=>{
                if(typeof(newObject[a][key])!=typeof(types[key])){
                    if(typeof(types[key])=='number'){
                        newObject[a][key] = Number(newObject[a][key])
                    }
                    if(typeof(types[key])=='string'){
                        newObject[a][key] = String(newObject[a][key])
                    }
                }
            })
        }

        await updateDoc(doc(db, 'arcalab_utils', 'lab_list'), {lab_list:newObject})
        .then(()=>{
            setLabData(labData.map((item:any, index:any)=>index==currentLab?{...form}:item))
        })
    }

    function filterRepeatedEmail(array:[]){
        let filtered:any=[]
        for(let a=0;a<array?.length;a++){
            if(!filtered.includes(array[a])){
                filtered.push(array[a])
            }
        }
        return(filtered)
    }

    async function newLab(){
        const object = {
            active: false,
            cupons: labData[labData.length-1].cupons,
            date: 'dd/mm/aaaa',
            id: 'arcalab_'+labData.length+1,
            link_zoom: '',
            max_online: 20,
            max_presencial: 12,
            price_online: labData[labData.length-1].price_online,
            price_presencial: labData[labData.length-1].price_presencial
        }
        await updateDoc(doc(db, 'arcalab_utils', 'lab_list'),{lab_list: arrayUnion(object)})
        .then(()=>{
            setLabData((prev:any)=>[...prev,...[object]])
        })
    }

    useEffect(()=>{
        if(labData.length>0){
            setChecked(labData[currentLab].active)
        }
    },[labData])

    useEffect(()=>{
        if(labData.length==0){
            getLabs()
        }
        if(accounts.length==0){
            getAccounts()
        }
    },[])

    useEffect(()=>{
        if(participants.length==0){
            getParticipants()
        }
        if(labData.length>0){
            if(Object.keys(form).length==0){
                setForm({...labData[currentLab]})
            }
        }
    },[currentLab])

    useEffect(()=>{
        setFilterAccounts(accounts)
    },[accounts])

    useEffect(()=>{
        if(Object.keys(form).length>0){
            let old_form = {...form}
            old_form.active = checked
            setForm(old_form)
        }
    },[checked])

    const info = [
        {name: 'Data', key:'date'},
        {name: 'Lotação Presencial', key:'max_presencial'},
        {name: 'Lotação Online', key:'max_online'},
        {name: 'Preço Online', key:'price_online'},
        {name: 'Preço Presencial', key:'price_presencial'},
        {name: 'Link Zoom', key:'link_zoom'},
    ]

    return(
        <div style={{width:'100%', backgroundColor:"#fafaf9", borderRadius:'10px', display:'flex', paddingBottom:'20px'}}>
            <div style={{display:'flex', flexDirection:'column', alignItems:'center', width:'75%'}}>
                <div style={{backgroundColor:"#000", borderRadius:'5px', padding:'5px 10px', color:"#fff", display:'flex', justifyContent:'left', width:'95%', marginTop:'10px', alignItems:'center', cursor:'pointer', position:'relative'}} onClick={()=>{setDropdown(!dropdown)}}>
                    <div style={{width:'fitContent', display:'inline-block', fontWeight:'600'}}>
                        {labData[currentLab]?.id}
                    </div>
                    <div style={{justifySelf:'right', display:'inline-block', width:'fitContent', marginLeft:'auto'}}>
                        <ArrowDropDownIcon/>
                    </div>
                    <div style={{backgroundColor:"#fff", borderRadius:'5px', padding:'10px 10px', color:"#000", display:!dropdown?'none':'flex', justifyContent:'left', width:'100%',alignItems:'start', cursor:'pointer', position:'absolute', boxSizing:'border-box', transform:'translateX(-10px)', top:'100%', boxShadow:boxShadow, flexDirection:'column'}}>
                        {labData.map((lab:any, index:any)=>{
                            return(
                                <div key={index} style={{fontWeight:'600',padding:'5px 0', width:'100%', textAlign:'left'}} onClick={()=>{setCurrentLab(index)}}>
                                    {lab?.id}
                                </div>
                            )
                        })}
                        <div style={{fontWeight:'600',padding:'5px 0', width:'100%', textAlign:'center', color:'#999', display:'flex', alignItems:'center', justifyContent:'center'}} onClick={()=>{}}>
                            <div style={{marginRight:'8px', transform:'translateY(3px)'}}>
                                <AddCircleIcon/>
                            </div>
                            <div onClick={()=>{newLab()}}>
                                Novo Laboratório
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{display:'flex', width:'95%'}}>
                    <div style={{width:'35%', display:'flex', flexDirection:'column'}}>
                        <div style={{borderRadius:'10px', boxShadow:boxShadow, display:'flex', flexDirection:'column', textAlign:'left', marginTop:"20px", padding:'20px'}}>
                            {info.map((el:any, index:any)=>{
                                return(
                                    <div key={index} style={{display:'flex', marginBottom:'5px'}}>
                                        <div style={{width:'50%'}}>
                                            {el.name}
                                        </div>
                                        <div style={{marginLeft:'auto', cursor:'pointer', display:'flex'}}>
                                            {el.key=='price_online'&&('R$')}
                                            {el.key=='price_presencial'&&('R$')}
                                            {labData.length>0&&(<Form id={el.key} defVal={String(labData[currentLab][el.key])}/>)}
                                        </div>
                                    </div>
                                )
                            })}
                            <div style={{display:'flex', alignItems:'center'}}>
                                <Switch checked={checked} onChange={()=>{setChecked(!checked)}}/>
                                <div style={{marginLeft:'auto'}}>
                                    {JSON.stringify(form)==JSON.stringify(labData[currentLab])&&
                                    (<CheckCircleIcon style={{color:'#27ae60'}}/>)||(
                                        <div style={{borderRadius:'5px', backgroundColor:'#d3edd5', padding:'5px 10px', fontSize:'12px', fontWeight:'600', cursor:'pointer'}} onClick={()=>{goSave()}}>
                                            Salvar Alterações
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{width:'65%', display:'flex', flexDirection:'column', marginLeft:'20px'}}>
                        <div style={{borderRadius:'10px', boxShadow:boxShadow, display:'flex', flexDirection:'column', textAlign:'left', marginTop:"20px", padding:'20px 10px'}}>
                            <div style={{borderRadius:'5px', padding:'5px 10px', color:"#fff", display:'flex', justifyContent:'center', width:'95%', alignItems:'center', boxShadow:boxShadow, marginBottom:'10px', alignSelf:'center', backgroundColor:'#000'}}>
                                <div style={{width:'30%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                                    <PersonIcon/>
                                    {participants[currentLab]?.filter(function(item:any){return(!item.online&&item.status==='paid')}).length}
                                </div>
                                <div style={{width:'30%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                                    <PodcastsIcon/>
                                    {participants[currentLab]?.filter(function(item:any){return(item.online&&item.status==='paid')}).length}
                                </div>
                                <div style={{width:'fitContent', textAlign:'right', marginLeft:'auto', fontWeight:'600', fontSize:'14px'}}>
                                    R${String(participants[currentLab]?.filter(function(item:any){if(item.status==='paid'){return(item)}}).reduce((partialSum:any, a:any)=> partialSum+a.valor,0).toFixed(2)).replace('.',',')}
                                </div>
                            </div>
                            <div style={{}}>
                            {participants[currentLab]?.map((part:any, index:any)=>{
                                return(
                                    <div key={index} style={{display:'flex', alignItems:'center', borderBottom:index<participants[currentLab].length-1?'1px solid #e6edf1':''}}>
                                        <div style={{width:'50%', marginLeft:'5px'}}>
                                            {part.nome}
                                        </div>
                                        <div style={{width:'15%', justifyContent:'center', display:'flex'}}>
                                            {part.online&&(<PodcastsIcon/>)||(<PersonIcon/>)}
                                        </div>
                                        <div style={{width:'15%', justifyContent:'center', display:'flex'}}>
                                            {part.pix&&(<PixIcon/>)||(<CreditCardIcon/>)}
                                        </div>
                                        <div style={{width:'fitContent', display:'inline-block', textAlign:'right', color:part.status==='paid'?'#27ae60':part.status==='pending'?'#f1c40f':'#F54927', fontWeight:'600', marginLeft:'auto', marginRight:'10px'}}>
                                            R${Number.isInteger(part.valor)?String(part.valor+',00'):String(part.valor).replace('.',',')}
                                        </div>
                                    </div>
                                )
                            })}
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{borderRadius:'10px', border:'1px solid #e0e0e0', width:'95%', marginTop:"20px", display:'flex', flexDirection:'column', overflow:'hidden', paddingBottom:'20px'}}>
                            <div style={{width:'100%', display:'flex', borderBottom:'1px solid #e0e0e0'}}>
                                <div style={{width:'50%', fontWeight:'600', color:contactWindow==0?"#fff":'#000', backgroundColor:contactWindow==0?'#000':'transparent', padding:'5px', fontSize:'12px', cursor:'pointer'}} onClick={()=>{setContactWindow(0)}}>
                                    E-mail
                                </div>
                                <div style={{width:'50%', fontWeight:'600', color:contactWindow==1?"#fff":'#000', backgroundColor:contactWindow==1?'#000':'transparent', padding:'5px', fontSize:'12px', cursor:'pointer'}} onClick={()=>{setContactWindow(1)}}>
                                    WhatsApp
                                </div>
                            </div>
                            {contactWindow==0&&(
                            <div style={{width:'100%', display:'flex'}}>
                                <div style={{width:'40%', display:'flex', flexDirection:'column'}}>
                                    <div style={{width:'100%'}}>
                                        {labData.map((lab:any, index:any)=>{
                                            return(
                                                <CheckItems key={index} label={lab.id} number={filterRepeatedEmail(participants[index]?.map((item:any)=>{return(item.email)})).length}/>
                                            )
                                        })}
                                        <div style={{clear:'both'}}/>
                                    </div>
                                    <div style={{width:'100%', color:"#000", display:'flex', flexDirection:'column', paddingLeft:'10px', maxHeight:'420px', overflow:'auto', alignItems:'start'}}>
                                        {filterRepeatedEmail(
                                            participants.map((lab:any)=>{
                                                return(
                                                    lab.map((part:any)=>{
                                                        return(part.email)
                                                    })
                                                )
                                            }).flat()
                                        ).map((email:any, index:any)=>{
                                            return(
                                                <EmailSelection key={index} email={email}/>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div style={{width:'60%', display:'flex', flexDirection:"column"}}>
                                    <div style={{borderRadius:'5px', padding:'5px 10px', color:"#fff", display:'flex', justifyContent:'left', width:'90%', margin:'10px 0', alignItems:'center', boxShadow:boxShadow}}>
                                        <div style={{justifySelf:'right', display:'inline-block', width:'90%'}}>
                                            <input type='text' style={{width:'100%', border:'none', outline:'none', fontSize:'16px', backgroundColor:'transparent'}} onChange={((e)=>{})}/>
                                        </div>
                                    </div>
                                    <div style={{width:'100%', display:'flex'}}>
                                        <div style={{width:'70%'}}>
                                            <div style={{width:'100%', height:'400px', boxShadow:boxShadow, borderRadius:'5px'}}>
                                            </div>
                                        </div>
                                        <div style={{display:'flex', flexDirection:'column', alignItems:'center', width:'30%'}}>
                                            <div style={{borderRadius:'5px', border:'1px solid #e0e0e0', display:'flex', flexDirection:'column', alignItems:'center', width:'60%', height:"100px",justifyContent:'center',cursor:'pointer', marginBottom:'10px'}}>
                                                <ArticleIcon style={{fontSize:"40px"}}/>
                                                <div style={{fontWeight:'500', fontSize:'12px', marginTop:'5px'}}>Template 1</div>
                                            </div>
                                            <div style={{borderRadius:'4px', border:'3px dashed #e0e0e0', display:'flex', flexDirection:'column', alignItems:'center', width:'60%', height:"100px",justifyContent:'center',cursor:'pointer', boxSizing:'border-box'}}>
                                                <AddIcon style={{fontSize:"40px"}}/>
                                                <div style={{fontWeight:'500', fontSize:'12px', marginTop:'5px'}}>Novo</div>
                                            </div>
                                            <div style={{display:'flex', borderRadius:"5px", width:'60%', padding:"5px",alignItems:'center', color:'#fff', backgroundColor:'#2a93d5', justifyContent:'center', cursor:'pointer', marginTop:'auto', boxShadow:boxShadow}}>
                                                <SendIcon style={{fontSize:'15px'}}/>
                                                <span style={{fontSize:'14px', fontWeight:'600', marginLeft:'5px'}}>Enviar</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                )}
                </div>
            </div>
            <div style={{display:'flex', flexDirection:'column', width:'25%'}}>
                    <div style={{borderRadius:'5px', padding:'5px 10px', color:"#fff", display:'flex', justifyContent:'left', width:'90%', margin:'10px 0', alignItems:'center', boxShadow:boxShadow}}>
                        <div style={{width:'fitContent', display:'inline-block', color:'#000'}}>
                            <SearchIcon/>
                        </div>
                        <div style={{justifySelf:'right', display:'inline-block', width:'90%'}}>
                            <input type='text' style={{width:'100%', border:'none', outline:'none', fontSize:'16px', backgroundColor:'transparent'}} onChange={((e)=>{setFilterAccounts(accounts.filter(function(acc:any){if(acc.email.includes(e.target.value.toUpperCase())){return(acc)}}))})}/>
                        </div>
                    </div>
                    <div style={{overflow:'auto', maxHeight:'100%'}}>
                {filterAccounts.map((acc:any, index:any)=>{
                    return(
                        <UserDisplay key={index} acc={acc}/>
                    )
                })}
                </div>

            </div>
        </div>
    )
}